import {http} from 'hiya-common/src/utils/axios'
import {
  resolveHomepageMock,
  HeartVoyageInviteHandleDeclineMock,
  HeartVoyageInviteHandleMock,
  HeartVoyageInviteListEmptyMock,
  HeartVoyageInviteListMock,
  HeartVoyageInviteListSearchMock,
  HeartVoyageInvitePendingEmptyMock,
  HeartVoyageInvitePendingMock,
  HeartVoyageInvitePendingSearchMock,
  HeartVoyageInviteSendMock,
  HeartVoyageJumpRoomMock,
  HeartVoyageRelationListMock,
  HeartVoyageRelationListWithLimitMock,
  resolveStageInfoMock,
  resolveDailyInfoMock,
  HeartVoyageDailyAreaRankMock,
  HeartVoyagePeakRankFinalsMock,
  HeartVoyagePeakRankMock,
  HeartVoyageUnbindMock,
  HeartVoyageBatchBindingInfoMock,
  GetActivityPendantsStageMock,
  HeartVoyageGiftBannerMock,
  HeartVoyageStageClaimMock,
  ProbGiftActRankMock,
  ProbGiftActHomeMock,
} from './mockMd'

/** 本地 Mock 开关：开发 / dev 预览 / 叠图 true，联调/上线前改 false */
export const SERVICE_MOCK_ENABLED = false

/** @see mockMd/heart_voyage_homepage.md · 主页请走 reducers.get_homepage */
export async function heart_voyage_homepage(
  params: {pair_key?: string; is_pop?: boolean} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    return resolveHomepageMock(params)
  }

  const res = await http.post(
    '/live/activity/heart_voyage_homepage',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_invite_list.md */
export async function heart_voyage_invite_list(
  params: {search_mid?: number} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    const searchMid = params.search_mid ?? 0
    if (!searchMid) {
      return HeartVoyageInviteListMock
    }
    if (searchMid === 123) {
      return HeartVoyageInviteListSearchMock
    }
    return HeartVoyageInviteListEmptyMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_invite_list',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_relation_list.md */
export async function heart_voyage_relation_list(
  params: {pair_key?: string} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    if (params.pair_key) {
      return HeartVoyageRelationListWithLimitMock
    }
    return HeartVoyageRelationListMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_relation_list',
    {},
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_unbind.md */
export async function heart_voyage_unbind(params: {pair_key: string}) {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageUnbindMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_unbind',
    {
      pair_key: params.pair_key,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_invite_send.md */
export async function heart_voyage_invite_send(params: {
  to_mid: number
  rel_type: number
}) {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageInviteSendMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_invite_send',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_invite_pending.md */
export async function heart_voyage_invite_pending(
  params: {search_mid?: number} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    const searchMid = params.search_mid ?? 0
    if (!searchMid) {
      return HeartVoyageInvitePendingMock
    }
    if (searchMid === 123) {
      return HeartVoyageInvitePendingSearchMock
    }
    return HeartVoyageInvitePendingEmptyMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_invite_pending',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_invite_handle.md */
export async function heart_voyage_invite_handle(params: {
  invite_id: string
  action: number
}) {
  if (SERVICE_MOCK_ENABLED) {
    if (params.action === 2) {
      return HeartVoyageInviteHandleDeclineMock
    }
    return HeartVoyageInviteHandleMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_invite_handle',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_jump_room.md */
export async function heart_voyage_jump_room(params: {to_mid: number}) {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageJumpRoomMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_jump_room',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_stage_info.md */
export async function heart_voyage_stage_info(
  params: {pair_key?: string} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    return resolveStageInfoMock()
  }

  const res = await http.post(
    '/live/activity/heart_voyage_stage_info',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_stage_claim.md */
export async function heart_voyage_stage_claim(
  params: {pair_key?: string} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageStageClaimMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_stage_claim',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_daily_info.md */
export async function heart_voyage_daily_info(
  params: {pair_key?: string} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    return resolveDailyInfoMock(params.pair_key)
  }

  const res = await http.post(
    '/live/activity/heart_voyage_daily_info',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_daily_area_rank.md */
export async function heart_voyage_daily_area_rank() {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageDailyAreaRankMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_daily_area_rank',
    {},
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_peak_rank.md */
export async function heart_voyage_peak_rank(
  params: {segment: number; group_id?: number} = {segment: 1}
) {
  if (SERVICE_MOCK_ENABLED) {
    if (params.segment === 2) {
      return HeartVoyagePeakRankFinalsMock
    }
    return HeartVoyagePeakRankMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_peak_rank',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/get_activity_pendants.md */
export async function get_activity_pendants() {
  if (SERVICE_MOCK_ENABLED) {
    return GetActivityPendantsStageMock
  }

  const res = await http.post(
    '/activity/httpapi/get_activity_pendants',
    {},
    {
      store: window.store,
    }
  )
  const raw = res.data?.data?.pendant?.heart_voyage
  if (!raw) {
    return null
  }
  return typeof raw === 'string' ? JSON.parse(raw) : raw
}

/** @see mockMd/heart_voyage_gift_banner.md */
export async function heart_voyage_gift_banner() {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageGiftBannerMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_gift_banner',
    {},
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/heart_voyage_batch_binding_info.md */
export async function heart_voyage_batch_binding_info(
  params: {mids?: number[]} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    return HeartVoyageBatchBindingInfoMock
  }

  const res = await http.post(
    '/live/activity/heart_voyage_batch_binding_info',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/prob_gift_act_rank.md */
export async function prob_gift_act_rank(
  params: {offset?: number; limit?: number} = {}
) {
  if (SERVICE_MOCK_ENABLED) {
    return ProbGiftActRankMock
  }

  const res = await http.post(
    '/live/gift/prob_gift_act_rank',
    {
      offset: params.offset ?? 0,
      limit: params.limit ?? 20,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/prob_gift_act_home.md */
export async function prob_gift_act_home() {
  if (SERVICE_MOCK_ENABLED) {
    return ProbGiftActHomeMock
  }

  const res = await http.post(
    '/live/gift/prob_gift_act_home',
    {},
    {
      store: window.store,
    }
  )
  return res.data.data
}
